import { render, staticRenderFns } from "./warningCenter.vue?vue&type=template&id=7956fab0&scoped=true&"
import script from "./warningCenter.vue?vue&type=script&lang=js&"
export * from "./warningCenter.vue?vue&type=script&lang=js&"
import style0 from "./warningCenter.vue?vue&type=style&index=0&id=7956fab0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7956fab0",
  null
  
)

export default component.exports